import axios from "axios";

export const get = async (url, params) => {
  try {
    return axios
      .create({
        responseType: "json",
        baseURL: "https://data.riskma.net/bosai"
      })
      .get(url, {
        params
      })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.error(err);
        return null;
      });
  } catch (e) {
    console.log(e);
  }
};

export const getOutsideApi = async (url, params) => {
  try {
    return axios
      .create({
        responseType: "json"
      })
      .get(url, {
        params
      })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.error(err);
        return null;
      });
  } catch (e) {
    console.log(e);
  }
};
export const postOutsideApi = async (url, params) => {
  try {
    return axios
      .create({
        responseType: "json"
      })
      .post(url, params)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.error(err);
        return null;
      });
  } catch (e) {
    console.log(e);
  }
};
export const deleteOutsideApi = async (url, params) => {
  try {
    return axios
      .create({
        responseType: "json"
      })
      .delete(url, { params })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.error(err);
        return null;
      });
  } catch (e) {
    console.log(e);
  }
};
export const putOutsideApi = async (url, params) => {
  try {
    return axios
      .create({
        responseType: "json"
      })
      .put(url, params)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.error(err);
        return null;
      });
  } catch (e) {
    console.log(e);
  }
};
